import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import BuoyOutlineIcon from '../../../components/icons/BuoyOutline';
import PlatformType from './PlatformType';
import PlatformEvent from './PlatformEvent';
import ConnectionStatus from './ConnectionStatus';

const OverviewCard = (props) => {
  const { obsDataset, obsLatestData } = props;

  const history = useHistory();

  const onCardClick = (obsDataset) => {
    history.push(`/data-console/manage/${obsDataset.obs_dataset_id}`);
  };

  const datasetLatestData = obsLatestData?.find((data) => data.obs_dataset_id === obsDataset.obs_dataset_id);

  const timestamps = (datasetLatestData?.parameters || []).flatMap((p) => (p.observations || []).map((obs) => obs.timestamp));

  const latestTimestamp = timestamps.length > 0 ? Math.max(...timestamps) : null;

  return (
    <Card
      key={obsDataset.obs_dataset_id}
      // variant="borderless"
      bordered={false}
      style={{
        backgroundColor: '#03304b', // TODO: replace with brand var
        border: '1px solid #4f6f81',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: 20,
        }}
      >
        <div
          style={{
            background: '#3f6c7f',
            borderRadius: '50%',
            height: 60,
            width: 60,
            flex: 1,
            maxWidth: 60,
            maxHeight: 60,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <BuoyOutlineIcon
            style={{
              color: '#fff',
              width: 25,
              height: 25,
            }}
          />
        </div>
        <div
          style={{
            flex: 1,
          }}
        >
          <Typography.Title
            onClick={() => onCardClick(obsDataset)}
            level={4}
            style={{
              color: '#fff',
              marginBottom: '0.2em',
              cursor: 'pointer',
            }}
          >
            {obsDataset.platform_name}
          </Typography.Title>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 24,
            }}
          >
            <Typography.Text
              style={{
                color: '#fff',
                opacity: 0.8,
                fontWeight: 'bold',
              }}
            >
              {obsDataset.org_platform_id}
            </Typography.Text>
            <PlatformType platformType={obsDataset.obs_dataset_platform_assignment?.platform?.platform_type} />
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '10px 0',
        }}
      >
        <PlatformEvent platformEvent={obsDataset?.obs_dataset_platform_assignment?.platform?.platform_event?.event} />
        <ConnectionStatus latestTimestamp={latestTimestamp} />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '10px 0',
          color: '#fff',
          opacity: 0.8,
        }}
      >
        <span>
          {obsDataset?.obs_dataset_platform_assignment?.platform?.platform_event?.event_time && (
            moment(obsDataset?.obs_dataset_platform_assignment?.platform?.platform_event?.event_time).fromNow()
          )}
        </span>
        <span>
          {latestTimestamp && (
            <>
              updated
              {' '}
              {moment(latestTimestamp * 1000).fromNow()}
            </>
          )}
        </span>
      </div>
    </Card>
  );
};

OverviewCard.propTypes = {
  obsDataset: PropTypes.object,
  obsLatestData: PropTypes.array,
};

OverviewCard.defaultProps = {
  obsDataset: {},
  obsLatestData: [],
};

export default OverviewCard;
